import endpoints from 'helper/endpoints'
import {fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_FLEET_FAIL,
  GET_FLEET_LIST_FAIL,
  GET_FLEET_LIST_REQUEST,
  GET_FLEET_LIST_SUCCESS,
  GET_FLEET_MAP_FAIL,
  GET_FLEET_MAP_SUCCESS,
  GET_FLEET_REQUEST,
  GET_FLEET_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getFleetList = (limit = 1200, offset = 0, meta, search, filter) => {
  return (dispatch) => {
    dispatch({type: GET_FLEET_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.fleets + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
        ...filter,
      })
      .then((res) => {
        dispatch({type: GET_FLEET_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_FLEET_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getFleet = (id) => {
  return (dispatch) => {
    dispatch({type: GET_FLEET_REQUEST})
    return httpClient
      .get(endpoints.fleets + '/' + id)
      .then((res) => {
        dispatch({type: GET_FLEET_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_FLEET_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const createFleet = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.fleets, data)
      .then((res) => {
        fireSuccessToast(<Trans>New fleet created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const patchFleet = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.fleets + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Fleet updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const getFleetMap = (id) => {
  return (dispatch) => {
    dispatch({type: GET_FLEET_LIST_REQUEST})
    return httpClient
      .get(`${endpoints.fleets}/${id}/supplier-map`)
      .then((res) => {
        dispatch({type: GET_FLEET_MAP_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_FLEET_MAP_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}
